import "./my_week.scss";
import { plannerIcons } from "../default_values/DefaultProjectIcons";
import { WhiteTooltip } from "../default_components/Tooltips";
import { ICON_COLOR, TeambookIcon } from "../default_images/TeambookIcon";
import { icons } from "../default_images/IconsList";
import lsKeys from "../default_values/defaultKeys";
import { linkToAnchor } from "../../lib/StringFormat";
import PropTypes from "prop-types";

const BookingIcons = ({
  booking,
  project,
  iconColor = ICON_COLOR.DEFAULT,
  switchTheme,
  variant,
  showComment = true,
  marginBottom = 6,
}) => {
  const getColor = () => {
    const isDarkTheme = localStorage.getItem(lsKeys.THEME) === "dark";

    if (isDarkTheme) {
      return booking.tentative ? "#FFFFFF" : "#1A1B23";
    } else {
      return booking.tentative ? "#FFFFFF" : "#474747";
    }
  };

  // to upload:  BOOKING_ON_CLIENT_SITE, BOOKING_AT_HOME, BOOKING_COMMENT, BOOKING_NON_BILLABLE, BOOKING_REPETITION

  return (
    <div className="booking__icons-container" style={{ marginBottom: marginBottom }}>
      {project.kind === "time_off" && plannerIcons(project.icon_id, getColor(), 0)}
      {booking.repetition && (
        <TeambookIcon
          name={variant === "blue" ? icons.REPETITION_BLUE : icons.BOOKING_REPETITION}
          color={iconColor}
          switchTheme={switchTheme}
        />
      )}
      {booking.location === 1 && (
        <TeambookIcon
          name={variant === "blue" ? icons.ON_CLIENT_SITE_BLUE : icons.BOOKING_ON_CLIENT_SITE}
          color={iconColor}
          switchTheme={switchTheme}
        />
      )}
      {booking.location === 2 && (
        <TeambookIcon
          name={variant === "blue" ? icons.AT_HOME_BLUE : icons.BOOKING_AT_HOME}
          color={iconColor}
          switchTheme={switchTheme}
        />
      )}

      {showComment && booking.comment.length > 0 && (
        <WhiteTooltip
          title={
            <span
              dangerouslySetInnerHTML={{
                __html: linkToAnchor(booking.comment),
              }}
            />
          }
        >
          <TeambookIcon name={icons.BOOKING_COMMENT} color={iconColor} switchTheme={switchTheme} />
        </WhiteTooltip>
      )}

      {booking.using_budget === false && (
        <TeambookIcon
          name={variant === "blue" ? icons.NON_BILLABLE_BLUE : icons.BOOKING_NON_BILLABLE}
          color={iconColor}
          switchTheme={switchTheme}
        />
      )}
    </div>
  );
};

BookingIcons.propTypes = {
  booking: PropTypes.object.isRequired,
  color: PropTypes.string,
  project: PropTypes.object.isRequired,
  iconColor: PropTypes.string,
  switchTheme: PropTypes.func.isRequired,
  marginBottom: PropTypes.number,
  showComment: PropTypes.bool,
  variant: PropTypes.string,
};

export default BookingIcons;
